import { useState } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

export default function GridOverlay() {
  const [visible, setVisible] = useState(false);

  useHotkeys('mod+shift+g', () => setVisible((v) => !v), {
    preventDefault: true,
  });

  if (!visible) return null;

  return (
    <div className="z-9999 pointer-events-none fixed inset-0">
      {/* Vertical columns */}
      <div className="container grid h-full grid-cols-12 gap-4">
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className="bg-red/10 h-full" />
        ))}
      </div>
    </div>
  );
}
